import { LANGUAGE_DEFAULT } from '@src/configs/const.config'
import { TCreatePost, TPatchPost, TQueryPost, TQueryPostViewSeries } from '@src/modules'

import { request } from './config'

export const createPost = (data: TCreatePost) => request({ url: 'post', method: 'POST', data })
export const getListPost = (params: TQueryPost, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: 'post', method: 'GET', params }, { token, lang })
export const getListPostApp = (params: TQueryPost, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: 'post/app', method: 'GET', params }, { token, lang })
export const getPostById = (id: string, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: `post/${id}`, method: 'GET' }, { token, lang })
export const patchPostById = (id: string, data: TPatchPost) => request({ url: `post/${id}`, method: 'PATCH', data })
export const removePostById = (id: string) => request({ url: `post/${id}`, method: 'DELETE' })
export const removeManyPostByIds = (data: { ids: string[] }) =>
  request({ url: `post/delete-many`, method: 'POST', data })
export const putSlugPostById = (id: string, slug: string) =>
  request({ url: `post/${id}/slug`, method: 'PUT', data: { slug } })
export const getTotalPost = (token?: string) => request({ url: `post/total`, method: 'GET' }, { token })
export const exportListPost = (params: TQueryPost, token?: string, lang = LANGUAGE_DEFAULT) =>
  request(
    {
      url: 'post/export-xlsx',
      method: 'GET',
      params,
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'blob',
    },
    { token, lang },
  )
export const getPostViewSeries = (id: string, params: TQueryPostViewSeries, token?: string) =>
  request({ url: `post/${id}/views/series`, method: 'GET', params }, { token })
